"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Upload = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Box_1 = require("../Box");
var Cell_1 = require("../Cell");
var ProgressBar_1 = require("../ProgressBar");
var Container = (0, styled_components_1.default)(Cell_1.Cell)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var Label = (0, styled_components_1.default)(Box_1.Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var Upload = function (_a) {
    var label = _a.label, progress = _a.progress, borderColor = _a.borderColor, foregroundColor = _a.foregroundColor, backgroundColor = _a.backgroundColor, progressBarColor = _a.progressBarColor, rest = __rest(_a, ["label", "progress", "borderColor", "foregroundColor", "backgroundColor", "progressBarColor"]);
    return (react_1.default.createElement(Container, __assign({ textColor: foregroundColor, borderColor: borderColor || foregroundColor }, rest),
        react_1.default.createElement(ProgressBar_1.ProgressBar, { progress: progress, color: progressBarColor, backgroundColor: backgroundColor, position: "absolute", top: 0, left: 0, height: "100%", width: "100%" }),
        react_1.default.createElement(Label, { textColor: foregroundColor },
            label,
            ": ",
            Math.floor(progress),
            "%")));
};
exports.Upload = Upload;
exports.Upload.displayName = "Upload";
exports.Upload.defaultProps = {
    foregroundColor: "primary",
    borderColor: "primary",
    backgroundColor: "background",
    progressBarColor: "tertiary",
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Upload.js.map